/**
 * Copy - Centered, Large module
 *
 * Simple copy module, with centered text.
 */

// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";

import { ContentMaxWidth } from "~/components/layout/max-width";
import HubSpotForm from "~/components/shared/hubspot/form";

export default function HubSpotFormWrapper({ block }) {
    const { hubspot_form_id, go_to_webinar_key, anchor_id } = block;

    if (!hubspot_form_id) return null;

    return (
        <Container id={anchor_id} className="module-hubspot-form">
            <ContentMaxWidth style={{ maxWidth: 600 }}>
                <HubSpotForm 
                    formId={hubspot_form_id}
                    prefix="form-module" 
                    goToWebinarKey={go_to_webinar_key}
                />
            </ContentMaxWidth>
        </Container>
    );
}

const Container = createComponent(
    () => ({
        extend: [
            fluid("paddingH", gutters.default),
            fluid("paddingV", gutters.vertical)
        ]
    }),
    "div",
    ["id"]
);
